{
  class TodaysHours extends HTMLElement {
    connectedCallback() {
      const hours = JSON.parse(this.dataset.hours || '{}');
      const day = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'][new Date().getDay()];
      const today = hours?.[day];

      if (today?.opening_hours && today?.closing_hours) {
        this.innerHTML = `Today's Hours: ${today.opening_hours} - ${today.closing_hours}`;
        if (today?.note) {
          this.innerHTML += `<br aria-hidden="true">${today.note}`;
        }
      } else {
        this.innerHTML = `Today's Hours: Closed`;
        if (today?.note) {
          this.innerHTML += `<br aria-hidden="true">${today.note}`;
        }
      }
    }
  }

  customElements.define('todays-hours', TodaysHours);
}